// Masonry Grid Component (v2.5 - Responsive columns + disable on 1 col)
export const MasonryGrid = (() => {
	const defaults = {
		selector: "[data-masonry]",
		itemSelector: "[data-masonry-item]",
		gap: 32, // px
		minColumnWidth: 520, // largeur minimale en px
		columns: 3, // nombre de colonnes souhaité max
		disableBelow: 600, // largeur en px en dessous de laquelle on désactive le layout
	};

	// --- Utils ---
	const debounceRAF = (fn) => {
		let frame;
		return (...args) => {
			if (frame) cancelAnimationFrame(frame);
			frame = requestAnimationFrame(() => fn(...args));
		};
	};

	const parseColumnConfig = (containerWidth, config) => {
		// Si largeur trop petite : on désactive complètement
		if (containerWidth < config.disableBelow) {
			return { colCount: 1, colWidth: containerWidth, disabled: true };
		}

		let colCount = config.columns;

		// Si pas assez de place pour toutes les colonnes, on réduit
		const minW = config.minColumnWidth + config.gap;
		const maxPossibleCols = Math.max(1, Math.floor((containerWidth + config.gap) / minW));
		colCount = Math.min(colCount, maxPossibleCols);

		const colWidth = (containerWidth - config.gap * (colCount - 1)) / colCount;

		return { colCount, colWidth, disabled: colCount === 1 };
	};

	const layoutMasonry = (container, config) => {
		const items = Array.from(container.querySelectorAll(config.itemSelector));
		if (!items.length) return;

		const containerWidth = container.clientWidth;
		const { colCount, colWidth, disabled } = parseColumnConfig(containerWidth, config);

		// Si désactivé : on réinitialise le style pour repasser en flux normal
		if (disabled) {
			container.style.position = "";
			container.style.height = "";
			items.forEach((item) => {
				item.style.position = "";
				item.style.width = "";
				item.style.transform = "";
			});
			return;
		}

		const colHeights = new Array(colCount).fill(0);
		container.style.position = "relative";

		items.forEach((item) => {
			item.style.position = "absolute";
			item.style.width = `${colWidth}px`;
			const h = item.offsetHeight;

			// colonne la plus courte
			let targetCol = 0;
			for (let i = 1; i < colCount; i++) {
				if (colHeights[i] < colHeights[targetCol]) targetCol = i;
			}

			const x = targetCol * (colWidth + config.gap);
			const y = colHeights[targetCol];
			item.style.transform = `translate(${x}px, ${y}px)`;

			colHeights[targetCol] += h + config.gap;
		});

		container.style.height = `${Math.max(...colHeights)}px`;
	};

	const init = (userOptions = {}) => {
		const config = { ...defaults, ...userOptions };

		let containers = [];
		if (typeof config.selector === "string") {
			containers = document.querySelectorAll(config.selector);
		} else if (config.selector instanceof Element) {
			containers = [config.selector];
		} else if (config.selector instanceof NodeList || Array.isArray(config.selector)) {
			containers = config.selector;
		}

		if (!containers.length) return;

		containers.forEach((container) => {
			const relayout = debounceRAF(() => layoutMasonry(container, config));

			const ro = new ResizeObserver(() => relayout());
			ro.observe(container);

			const images = container.querySelectorAll("img");
			images.forEach((img) => {
				if (img.complete) return;
				img.addEventListener("load", relayout, { once: true });
			});

			relayout();
		});
	};

	return { init };
})();
